export default __webpack_public_path__ + "static/topNavItems-do-2-light-c2c616446bb74e00caa8ee65be8121ca155694bd847cdd8c3089220a1a7bd101.png";